import { render, staticRenderFns } from "./AssuntoPesquisa.vue?vue&type=template&id=1c33c38c&"
import script from "./AssuntoPesquisa.vue?vue&type=script&lang=js&"
export * from "./AssuntoPesquisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AssuntoPesquisa.vue"
export default component.exports